module.exports = __webpack_public_path__ + "img/new_paradigm.5e92bfcb.png";